var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "562px",
    height: "507px",
    viewBox: "0 0 562 507",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.9%",
    y: "-2.9%",
    width: "105.9%",
    height: "105.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.522,0 L38.0874076,0 C39.7104809,5.90024691e-16 41.0392209,1.29085841 41.0861532,2.91325303 L41.1416162,4.83054893 C41.2194359,7.52068827 43.4226581,9.66109785 46.1139228,9.66109785 L117.893594,9.66109785 C120.584859,9.66109785 122.788081,7.52068827 122.865901,4.83054893 L122.921364,2.91325303 C122.968296,1.29085841 124.297036,2.07451057e-15 125.92011,0 L145.485517,0 C155.714935,-2.00502105e-14 164.007517,8.29258186 164.007517,18.522 L164.007517,332.22284 C164.007517,342.452258 155.714935,350.74484 145.485517,350.74484 L18.522,350.74484 C8.29258186,350.74484 -2.29997126e-15,342.452258 0,332.22284 L0,18.522 C-4.8054561e-15,8.29258186 8.29258186,-8.77902741e-15 18.522,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.756748,0 L175.091515,0 C179.927734,-1.80700981e-14 183.848263,3.92052962 183.848263,8.756748 L183.848263,111.729076 C183.848263,116.565294 179.927734,120.485824 175.091515,120.485824 L8.756748,120.485824 C3.92052962,120.485824 -1.00658751e-14,116.565294 0,111.729076 L0,8.756748 C-5.92265936e-16,3.92052962 3.92052962,4.44111258e-15 8.756748,0 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-15.0%",
    y: "-22.8%",
    width: "135.4%",
    height: "153.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.94364704,0 L186.337323,0 C188.515339,0 190.28097,1.77062872 190.28097,3.95480995 L190.28097,107.768571 C190.28097,109.952752 188.515339,111.723381 186.337323,111.723381 L3.94364704,111.723381 C1.76563092,111.723381 0,109.952752 0,107.768571 L0,3.95480995 C0,1.77062872 1.76563092,0 3.94364704,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.5%",
    y: "-17.9%",
    width: "125.2%",
    height: "143.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.018993433   0 0 0 0 0.018993433   0 0 0 0 0.018993433  0 0 0 0.11 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "12.6306609%",
    x2: "50%",
    y2: "69.6202749%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.2040008%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.8140277%",
    y1: "-28.1859254%",
    x2: "62.8129202%",
    y2: "121.546626%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-6.92193591%",
    x2: "55.1442779%",
    y2: "91.2389276%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.0132116%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "21.1600743%",
    x2: "50%",
    y2: "65.1420198%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.1363582%",
    y1: "-28.1859254%",
    x2: "62.0165421%",
    y2: "121.546626%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-6.21125376%",
    x2: "55.1442779%",
    y2: "90.724051%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "-3.86473242%",
    x2: "50%",
    y2: "78.280962%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.5029159%",
    y1: "98.647392%",
    x2: "77.0614974%",
    y2: "9.20071293%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.3599603%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "28.060564%",
    x2: "50%",
    y2: "61.5190094%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "8.53256506%",
    x2: "50%",
    y2: "71.7719257%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.33786584,0 L27.3127906,0 C28.3393209,0 29.1714881,0.815063369 29.1714881,1.82049499 L29.1714881,1.87249734 C29.1714881,2.98437362 29.7116327,4.02990997 30.6262824,4.68848466 L31.1958621,5.09859875 C32.1105118,5.75717343 32.6506564,6.80270979 32.6506564,7.91458606 L32.6506564,35.1251064 C32.6506564,37.0553612 31.0530393,38.6201418 29.0822786,38.6201418 L3.56837775,38.6201418 C1.59761714,38.6201418 1.64410348e-13,37.0553612 1.64410348e-13,35.1251064 L1.64410348e-13,7.91458606 C1.64410348e-13,6.80270979 0.540144605,5.75717343 1.45479433,5.09859875 L2.02437398,4.68848466 C2.87804705,4.07381495 3.40548456,3.12205863 3.47201545,2.09389307 L3.4791683,1.82049499 C3.4791683,0.815063369 4.31133554,0 5.33786584,0 Z",
    id: "path-22"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error",
    transform: "translate(-436.000000, -279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(442.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#7367F0",
    opacity: 0.099999994,
    filter: "url(#filter-1)",
    cx: 101.744606,
    cy: 229.5,
    rx: 101.744606,
    ry: 102.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.905882,45.9562334 C373.403877,45.9562334 330.031933,89.3264216 330.031933,142.82626 C330.031933,196.326098 373.403877,239.696286 426.905882,239.696286 C480.407887,239.696286 523.779832,196.326098 523.779832,142.82626 C523.779832,89.3264216 480.407887,45.9562334 426.905882,45.9562334 Z M427.346218,87.3461538 C457.745085,87.3461538 482.388235,111.988306 482.388235,142.385942 C482.388235,172.783577 457.745085,197.425729 427.346218,197.425729 C396.947352,197.425729 372.304202,172.783577 372.304202,142.385942 C372.304202,111.988306 396.947352,87.3461538 427.346218,87.3461538 Z",
    id: "Oval",
    fill: "#00CFE8",
    fillRule: "nonzero",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#7367F0",
    strokeWidth: 30,
    opacity: 0.099999994,
    cx: 269.822706,
    cy: 33.5,
    rx: 33.4161207,
    ry: 33.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.271384,45.9562334 C480.571528,45.9562334 523.779832,89.3264216 523.779832,142.82626 C523.779832,196.326098 480.571528,239.696286 427.271384,239.696286 C395.161492,239.696286 365.687399,223.816071 347.797366,197.79554 C341.28687,188.326214 343.656823,175.352236 353.090803,168.817348 C362.430443,162.347809 375.192173,164.614607 381.763601,173.848667 L381.96083,174.130618 C392.182099,188.997155 408.950558,198.031759 427.271384,198.031759 C457.646735,198.031759 482.270822,173.315415 482.270822,142.82626 C482.270822,112.641996 458.136754,88.1156651 428.180901,87.6281569 L427.271384,87.620761 C415.808988,87.620761 406.51688,78.2938388 406.51688,66.7884972 C406.51688,55.2831556 415.808988,45.9562334 427.271384,45.9562334 Z",
    id: "Path",
    fill: "#00CFE8",
    fillRule: "nonzero",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Banking-App",
    transform: "translate(16.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone3",
    transform: "translate(127.710362, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.137,0 L152.247017,0 C166.129799,-2.55022564e-15 177.384017,11.2542182 177.384017,25.137 L177.384017,342.625425 C177.384017,356.508207 166.129799,367.762425 152.247017,367.762425 L25.137,367.762425 C11.2542182,367.762425 -2.32880507e-14,356.508207 -2.49882011e-14,342.625425 L-2.49882011e-14,25.137 C-2.66883515e-14,11.2542182 11.2542182,2.55022564e-15 25.137,0 Z",
    id: "Rectangle",
    fill: "#8EE9F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(6.397456, 7.410940)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.548951049,
    fill: "#E97EFF",
    mask: "url(#mask-3)",
    cx: 62.1796886,
    cy: 213.476888,
    rx: 14.0671067,
    ry: 14.052506
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5893471,60.2167446 L140.652559,60.2167446 C143.199132,60.2167446 145.263537,62.28115 145.263537,64.8277232 C145.263537,67.3742963 143.199132,69.4387017 140.652559,69.4387017 L24.5893471,69.4387017 C22.042774,69.4387017 19.9783686,67.3742963 19.9783686,64.8277232 C19.9783686,62.28115 22.042774,60.2167446 24.5893471,60.2167446 Z",
    id: "Rectangle",
    fillOpacity: 0.548951049,
    fill: "#E97EFF",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.3068967,6.43835799 C99.824289,6.43835799 101.054378,7.61801822 101.054378,9.07320286 C101.054378,10.4960501 99.8783522,11.6554823 98.4076202,11.70631 L98.3068967,11.7080477 L67.23961,11.7080477 C65.7222177,11.7080477 64.4921282,10.5283875 64.4921282,9.07320286 C64.4921282,7.65035566 65.6681545,6.49092339 67.1388864,6.44009571 L67.23961,6.43835799 L98.3068967,6.43835799 Z",
    id: "Path",
    fill: "#00CFE8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.44093,5.99921718 C110.958322,5.99921718 112.188412,7.22802992 112.188412,8.74384725 C112.188412,10.2259798 111.012385,11.4337217 109.541653,11.4866672 L109.44093,11.4884773 L109.296824,11.4884773 C107.779432,11.4884773 106.549342,10.2596646 106.549342,8.74384725 C106.549342,7.26171475 107.725368,6.05397281 109.1961,6.00102731 L109.296824,5.99921718 L109.44093,5.99921718 Z",
    id: "Path",
    fill: "#00CFE8",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BoardPieChart",
    transform: "translate(144.671894, 174.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#A8EDF6",
    mask: "url(#mask-5)",
    points: "-4.12480078 -4.72493426 188.562321 -4.72493426 188.562321 30.7120727 -4.12480078 30.7120727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0925389,19.4903538 L76.0101071,19.4903538 C76.9886731,19.4903538 77.7819575,20.2836382 77.7819575,21.2622042 C77.7819575,22.2407701 76.9886731,23.0340545 76.0101071,23.0340545 L17.0925389,23.0340545 C16.113973,23.0340545 15.3206886,22.2407701 15.3206886,21.2622042 C15.3206886,20.2836382 16.113973,19.4903538 17.0925389,19.4903538 Z",
    id: "Rectangle",
    fill: "#6FA3FF",
    opacity: 0.365606399,
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    mask: "url(#mask-5)",
    x: 15.3206886,
    y: 9.44986852,
    width: 32.9984062,
    height: 3.5437007
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EA5455",
    mask: "url(#mask-5)",
    x: 21.2132611,
    y: 89.773751,
    width: 32.9984062,
    height: 4.13431748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2804199,101.586087 L40.3593635,101.586087 C41.5010238,101.586087 42.4265223,102.511585 42.4265223,103.653245 C42.4265223,104.794906 41.5010238,105.720404 40.3593635,105.720404 L23.2804199,105.720404 C22.1387596,105.720404 21.2132611,104.794906 21.2132611,103.653245 C21.2132611,102.511585 22.1387596,101.586087 23.2804199,101.586087 Z",
    id: "Rectangle",
    fill: "#F8F9FA",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF9F43",
    fillRule: "nonzero",
    mask: "url(#mask-5)",
    x: 73.6571567,
    y: 89.773751,
    width: 32.9984062,
    height: 4.13431748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7243154,101.586087 L92.8032591,101.586087 C93.9449193,101.586087 94.8704178,102.511585 94.8704178,103.653245 C94.8704178,104.794906 93.9449193,105.720404 92.8032591,105.720404 L75.7243154,105.720404 C74.5826552,105.720404 73.6571567,104.794906 73.6571567,103.653245 C73.6571567,102.511585 74.5826552,101.586087 75.7243154,101.586087 Z",
    id: "Rectangle",
    fill: "#F8F9FA",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#28C76F",
    mask: "url(#mask-5)",
    x: 127.868824,
    y: 89.773751,
    width: 32.9984062,
    height: 4.13431748
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.935983,101.586087 L147.014926,101.586087 C148.156587,101.586087 149.082085,102.511585 149.082085,103.653245 C149.082085,104.794906 148.156587,105.720404 147.014926,105.720404 L129.935983,105.720404 C128.794323,105.720404 127.868824,104.794906 127.868824,103.653245 C127.868824,102.511585 128.794323,101.586087 129.935983,101.586087 Z",
    id: "Rectangle",
    fill: "#F8F9FA",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.213261, 46.658726)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.147314, 0.147654)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.426881, 43.853296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.941146,33.960465 C26.2974826,33.960465 33.8822921,26.358156 33.8822921,16.9802325 C33.8822921,7.60230904 26.2974826,0 16.941146,0 C7.58480944,0 0,7.60230904 0,16.9802325 C0,26.358156 7.58480944,33.960465 16.941146,33.960465 Z M16.941146,27.168372 C11.3273441,27.168372 6.77645842,22.6069866 6.77645842,16.9802325 C6.77645842,11.3534784 11.3273441,6.792093 16.941146,6.792093 C22.554948,6.792093 27.1058337,11.3534784 27.1058337,16.9802325 C27.1058337,22.6069866 22.554948,27.168372 16.941146,27.168372 Z",
    id: "Oval",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8822921,16.9802325 C33.8822921,7.60230904 26.2974826,0 16.941146,0 C15.0698787,0 13.5529168,1.52046181 13.5529168,3.3960465 C13.5529168,5.27163119 15.0698787,6.792093 16.941146,6.792093 C22.4911548,6.792093 27.0022672,11.2503996 27.1040758,16.7888292 L27.1058337,16.9802325 C27.1058337,18.8558172 28.6227956,20.376279 30.4940629,20.376279 C32.3653302,20.376279 33.8822921,18.8558172 33.8822921,16.9802325 Z",
    id: "Path",
    fill: "#28C76F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.393728, 43.853296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.941146,33.960465 C26.2974826,33.960465 33.8822921,26.358156 33.8822921,16.9802325 C33.8822921,7.60230904 26.2974826,0 16.941146,0 C7.58480944,0 0,7.60230904 0,16.9802325 C0,26.358156 7.58480944,33.960465 16.941146,33.960465 Z M16.941146,27.168372 C11.3273441,27.168372 6.77645842,22.6069866 6.77645842,16.9802325 C6.77645842,11.3534784 11.3273441,6.792093 16.941146,6.792093 C22.554948,6.792093 27.1058337,11.3534784 27.1058337,16.9802325 C27.1058337,22.6069866 22.554948,27.168372 16.941146,27.168372 Z",
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.941146,33.960465 C26.2974826,33.960465 33.8822921,26.358156 33.8822921,16.9802325 C33.8822921,7.60230904 26.2974826,0 16.941146,0 C15.0698787,0 13.5529168,1.52046181 13.5529168,3.3960465 C13.5529168,5.27163119 15.0698787,6.792093 16.941146,6.792093 C22.554948,6.792093 27.1058337,11.3534784 27.1058337,16.9802325 C27.1058337,22.5430462 22.6577896,27.0645666 17.1321088,27.1666101 L16.941146,27.168372 C15.0698787,27.168372 13.5529168,28.6888338 13.5529168,30.5644185 C13.5529168,32.4400032 15.0698787,33.960465 16.941146,33.960465 Z",
    id: "Path",
    fill: "#FF9F43",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.360575, 43.853296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.941146,33.960465 C26.2974826,33.960465 33.8822921,26.358156 33.8822921,16.9802325 C33.8822921,7.60230904 26.2974826,0 16.941146,0 C7.58480944,0 0,7.60230904 0,16.9802325 C0,26.358156 7.58480944,33.960465 16.941146,33.960465 Z M16.941146,27.168372 C11.3273441,27.168372 6.77645842,22.6069866 6.77645842,16.9802325 C6.77645842,11.3534784 11.3273441,6.792093 16.941146,6.792093 C22.554948,6.792093 27.1058337,11.3534784 27.1058337,16.9802325 C27.1058337,22.6069866 22.554948,27.168372 16.941146,27.168372 Z",
    id: "Oval",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,16.9802325 C0,26.358156 7.58480944,33.960465 16.941146,33.960465 C26.2974826,33.960465 33.8822921,26.358156 33.8822921,16.9802325 C33.8822921,7.60230904 26.2974826,0 16.941146,0 C15.0698787,0 13.5529168,1.52046181 13.5529168,3.3960465 C13.5529168,5.27163119 15.0698787,6.792093 16.941146,6.792093 C22.554948,6.792093 27.1058337,11.3534784 27.1058337,16.9802325 C27.1058337,22.6069866 22.554948,27.168372 16.941146,27.168372 C11.3273441,27.168372 6.77645842,22.6069866 6.77645842,16.9802325 C6.77645842,15.1046478 5.25949653,13.584186 3.38822921,13.584186 C1.51696189,13.584186 0,15.1046478 0,16.9802325 Z",
    id: "Path",
    fill: "#EA5455"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "VisaCard2",
    transform: "translate(142.676420, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BFB9FF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(26.619618, 16.699567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(0.000000, 0.982327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(101.154547, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#8E83FF",
    cx: 11.4365764,
    cy: 11.394999,
    rx: 11.4365764,
    ry: 11.394999
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-10",
    fill: "#FFBB7A",
    cx: 27.2111646,
    cy: 11.394999,
    rx: 11.4365764,
    ry: 11.394999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2203633,3.24290494 L19.3252499,3.14472842 C21.511033,5.22016898 22.8731528,8.14909221 22.8731528,11.394999 C22.8731528,14.6409058 21.511033,17.569829 19.3252499,19.6452696 C17.1371185,17.5707115 15.7745882,14.6413948 15.7745882,11.394999 C15.7745882,8.19994704 17.0943607,5.31202383 19.2203633,3.24290494 L19.3252499,3.14472842 L19.2203633,3.24290494 Z",
    id: "Path",
    fillOpacity: 0.416193182,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.57745882,18.6642225 L25.4365234,18.6642225 C26.3077299,18.6642225 27.0139822,19.3679073 27.0139822,20.2359465 L27.0139822,37.5249105 C27.0139822,38.3929497 26.3077299,39.0966345 25.4365234,39.0966345 L1.57745882,39.0966345 C0.706252369,39.0966345 4.37832775e-14,38.3929497 4.37832775e-14,37.5249105 L4.37832775e-14,20.2359465 C4.37832775e-14,19.3679073 0.706252369,18.6642225 1.57745882,18.6642225 Z",
    id: "Rectangle",
    fill: "#9F95FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(0.000000, 0.589397)",
    fill: "#FFFFFF",
    fillOpacity: 0.64690778
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54928234,51.08103 L23.2675176,51.08103 C25.2277321,51.08103 26.8167999,52.6643208 26.8167999,54.617409 C26.8167999,56.5704972 25.2277321,58.153788 23.2675176,58.153788 L3.54928234,58.153788 C1.58906783,58.153788 -9.10692171e-14,56.5704972 -9.10692171e-14,54.617409 C-9.10692171e-14,52.6643208 1.58906783,51.08103 3.54928234,51.08103 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54928234,68.762925 L52.8448704,68.762925 C54.8050849,68.762925 56.3941527,70.3462158 56.3941527,72.299304 C56.3941527,74.2523922 54.8050849,75.835683 52.8448704,75.835683 L3.54928234,75.835683 C1.58906783,75.835683 -8.7566555e-14,74.2523922 -8.7566555e-14,72.299304 C-8.7566555e-14,70.3462158 1.58906783,68.762925 3.54928234,68.762925 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.943223,68.762925 L135.661458,68.762925 C137.621673,68.762925 139.210741,70.3462158 139.210741,72.299304 C139.210741,74.2523922 137.621673,75.835683 135.661458,75.835683 L115.943223,75.835683 C113.983009,75.835683 112.393941,74.2523922 112.393941,72.299304 C112.393941,70.3462158 113.983009,68.762925 115.943223,68.762925 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54928234,0 L23.2675176,0 C25.2277321,0 26.8167999,1.58329081 26.8167999,3.536379 C26.8167999,5.48946719 25.2277321,7.072758 23.2675176,7.072758 L3.54928234,7.072758 C1.58906783,7.072758 0,5.48946719 0,3.536379 C0,1.58329081 1.58906783,0 3.54928234,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6195645,51.08103 L60.3377998,51.08103 C62.2980143,51.08103 63.8870821,52.6643208 63.8870821,54.617409 C63.8870821,56.5704972 62.2980143,58.153788 60.3377998,58.153788 L40.6195645,58.153788 C38.65935,58.153788 37.0702822,56.5704972 37.0702822,54.617409 C37.0702822,52.6643208 38.65935,51.08103 40.6195645,51.08103 Z",
    id: "Rectangle-Copy-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4785761,51.08103 L98.1968114,51.08103 C100.157026,51.08103 101.746094,52.6643208 101.746094,54.617409 C101.746094,56.5704972 100.157026,58.153788 98.1968114,58.153788 L78.4785761,58.153788 C76.5183616,58.153788 74.9292938,56.5704972 74.9292938,54.617409 C74.9292938,52.6643208 76.5183616,51.08103 78.4785761,51.08103 Z",
    id: "Rectangle-Copy-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.548858,51.08103 L135.267094,51.08103 C137.227308,51.08103 138.816376,52.6643208 138.816376,54.617409 C138.816376,56.5704972 137.227308,58.153788 135.267094,58.153788 L115.548858,58.153788 C113.588644,58.153788 111.999576,56.5704972 111.999576,54.617409 C111.999576,52.6643208 113.588644,51.08103 115.548858,51.08103 Z",
    id: "Rectangle-Copy-40"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Men1.1",
    transform: "translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(58.512695, 131.473650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8596382,184.216749 C45.8596382,184.216749 45.7238561,192.900053 51.0564417,195.98427 C56.3884292,199.069089 64.6496002,204.800442 64.6496002,204.800442 L33.2229355,205.865189 L34.1189774,184.138591 L45.8596382,184.216749 Z",
    id: "Path",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8915556,194.731345 C35.3218747,194.98205 34.7907097,198.497336 39.2003363,198.325991 C42.4130472,198.200939 47.4238234,192.275394 51.5457356,194.470419 C57.8371698,197.820372 65.2142621,202.337878 67.0230943,203.413446 C68.8319265,204.489616 69.5467263,208.547195 64.2015793,209.044998 C59.0903124,209.521158 52.1905508,209.468252 50.46247,209.153217 C48.7337911,208.838182 45.5275746,206.633537 42.9483139,206.985848 C40.3690532,207.338759 40.0753572,208.227965 38.6337945,208.621745 C37.1922318,209.015525 32.8413102,209.100911 32.3902985,207.886463 C31.872293,206.492253 31.3530912,194.573226 32.8915556,194.731345 Z",
    id: "Path",
    fill: "#482B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.455853,-1.74975703e-14 C30.455853,-1.74975703e-14 42.4441515,94.0992879 43.4466656,102.998427 C44.4485816,111.897566 49.9522406,175.205183 49.1991587,183.649806 C48.431721,192.249542 32.3442403,192.295835 30.1860834,185.807556 C27.2323753,176.926453 20.4037945,132.540779 19.2744707,123.271895 C18.1451469,114.00301 18.5417262,103.241918 14.0028973,93.7511861 C10.7531006,86.9562888 -3.0465246e-14,2.41266351 -3.0465246e-14,2.41266351 L30.455853,-1.74975703e-14 Z",
    id: "Path",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4098157,108.740088 L23.4524851,109.163528 C23.9100777,114.078795 24.2936454,130.360139 24.603188,158.007558 L23.9131005,153.878206 C21.7491919,140.78419 19.8277807,127.813166 19.2744707,123.271895 C18.1686745,114.196112 18.5258643,103.689649 14.2802062,94.345986 L14.0028973,93.7511861 C12.5726605,90.7607491 9.68912097,72.7112882 6.90849722,53.4369811 L7.78157912,55.7745555 C17.0654529,80.7422616 22.2750341,98.3977367 23.4098157,108.740088 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.590959821
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.8694799,
    y1: 195.980821,
    x2: 52.3659458,
    y2: 198.230354,
    id: "Path-10",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.4945425,
    y1: 196.860309,
    x2: 54.9910084,
    y2: 199.109841,
    id: "Path-10",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(25.694421, 133.776553)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-10)",
    points: "5.65408899 183.905747 2.84154635 202.895628 16.435303 202.827089 15.9902729 183.552836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.336923904,205.968069 C0.291463836,204.860035 1.32296096,197.674031 2.84154635,194.828814 C3.9430228,192.765091 6.38550559,192.281479 9.95950437,192.26705 C14.5695142,192.249014 18.4222549,192.946419 18.4168715,194.828814 C18.4007212,200.589026 19.861425,205.019356 19.959523,205.525577 C20.2478356,207.01057 16.124727,208.119205 10.493062,208.062691 C5.88365037,208.016999 0.407506641,207.695952 0.336923904,205.968069 Z",
    id: "Path",
    fill: "#482B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8649585,0.786725305 C47.8649585,0.786725305 41.6321439,42.7843853 37.8595564,69.3573518 C34.1521682,95.4685875 23.1727937,173.355279 22.0382564,181.508629 C20.9967304,188.993554 1.98526999,188.993554 2.18536616,179.928644 C2.38546234,170.863735 0.625368036,114.375501 4.16527176,106.012041 C7.70517548,97.648582 4.62346139,87.9149607 4.75206553,79.7901826 C4.88126783,71.6654044 9.9721973,1.32961969 9.9721973,1.32961969 L47.8649585,0.786725305 Z",
    id: "Path",
    fill: "#3A3669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7676928,55.2475203 L13.4701404,56.3283933 C9.86111031,69.2958219 8.61557961,70.4641322 9.63842469,91.1466077 L9.64893195,91.5670632 C9.68454132,96.7705105 7.20993462,123.697789 2.22511185,172.348898 L2.2025528,169.324565 C2.02775358,149.476985 1.29658442,113.5919 4.07538987,106.237031 L4.16527176,106.012041 C7.70517548,97.648582 4.62346139,87.9149607 4.75206553,79.7901826 C4.88126783,71.6654044 9.9721973,1.32961969 9.9721973,1.32961969 L16.475231,1.23558681 L16.5417322,4.45770102 C17.0095681,29.6195005 16.0848883,46.5494403 13.7676928,55.2475203 L13.7676928,55.2475203 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.46156529
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.31269816,
    y1: 196.479213,
    x2: 13.2887771,
    y2: 196.479213,
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.31269816,
    y1: 199.117675,
    x2: 13.2887771,
    y2: 199.117675,
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(46.019844, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22314161,49.7114555 C4.22314161,49.7114555 9.43027723,48.4827837 9.61092119,39.9070966 C9.79156514,31.3314095 9.66475548,28.4041086 9.66475548,28.4041086 L22.0095566,28.1960892 C22.0095566,28.1960892 22.1345846,37.7535549 22.1363663,41.2105241 C22.1411515,50.4954695 28.5779418,49.7114555 28.5779418,49.7114555 C28.5779418,49.7114555 27.2398571,57.2400368 16.8468481,57.8274209 C8.73222592,58.2867468 4.22314161,49.7114555 4.22314161,49.7114555 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head1",
    transform: "translate(0.513241, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01800308,24.0692846 C2.90135279,23.8702835 3.73593791,31.3988828 9.05117692,31.3886622 C9.05117692,31.3886622 14.7634633,42.933016 23.7316345,42.9630513 C28.0515373,42.9774001 29.4619957,39.1098037 30.7570095,36.3947306 C32.0520233,33.6796575 33.0024976,29.6184708 33.0814546,27.1318582 C33.1663931,24.4805136 33.17716,15.770155 33.17716,15.770155 L7.81881621,15.758732 L8.01800308,24.0692846 Z",
    id: "Path",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3703053,37.5863503 C24.1771961,37.9270369 25.0739509,37.727591 25.7433081,37.3369377",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(24.556807, 37.548761) rotate(6.000000) translate(-24.556807, -37.548761) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52904594,28.4931012 C8.85196441,27.3282384 8.71058267,26.3112863 7.55990676,25.8478461",
    id: "Path-8",
    stroke: "#DE6767",
    strokeLinecap: "round",
    transform: "translate(8.119765, 27.170474) rotate(-13.000000) translate(-8.119765, -27.170474) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01800308,24.0692846 C8.01800308,24.0692846 10.3705616,26.7987868 11.2408826,26.8739383 C12.1118018,26.9490898 11.1194564,19.4868472 12.4013107,18.127507 C15.2168441,15.1400849 22.5739898,20.2164085 30.3107831,18.9764183 C32.221701,18.6701519 33.1601299,20.1497152 33.1260697,23.4151081 C40.3584077,16.7861453 42.9803844,11.5568617 34.3381862,9.37325997 C34.2687998,3.76275015 31.0578834,2.35471179 24.8489951,4.95735827 C24.0190498,-2.62164084 13.2910719,-1.47753198 8.40784921,8.16417313 C4.87336003,4.70738419 -0.094723813,7.49773479 2.01368515,12.6991644 C-1.7924239,12.6991644 0.190975117,22.9254819 4.67629676,26.4385411 C5.21145364,24.903917 6.18946383,24.0692846 8.01800308,24.0692846 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8151039,34.3235476 C21.8151039,34.3235476 23.5720864,37.1796172 27.0120421,36.1589999",
    id: "Path",
    stroke: "#DE6767",
    strokeLinecap: "round",
    transform: "translate(24.413573, 35.351447) rotate(-15.000000) translate(-24.413573, -35.351447) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(75.023733, 54.907179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(76.137061, 15.721892) rotate(4.000000) translate(-76.137061, -15.721892) translate(65.137061, 2.221892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.9945718e-14,20.9033963 C-6.9945718e-14,20.9033963 0.893107213,12.6813133 2.62657139,9.70110576 C4.36003556,6.72029696 4.5889357,1.9000986 6.42468503,1.94819556 C8.26043436,1.99689373 6.96795175,9.75692692 6.96795175,9.75692692 C6.96795175,9.75692692 15.0245525,2.78286842 18.7289499,0.314893414 C22.1085471,-1.93604409 20.9026589,8.57193819 20.4450675,9.9324808 C19.3552221,13.1718107 5.02691979,26.1110107 5.02691979,26.1110107 C5.02691979,26.1110107 0.381625308,21.6026058 -6.9945718e-14,20.9033963 Z",
    id: "Path",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96795175,9.75692692 C6.67105308,11.5267189 6.62709931,12.4042705 6.83609045,12.3895819 C7.04508159,12.3748932 8.91451361,9.9633203 12.4443865,5.15486321 L6.96795175,9.75692692 Z",
    id: "Path",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4402651,4.12195695 C19.6081297,13.1608034 35.1968377,36.5157694 35.1968377,36.5157694 C35.1968377,36.5157694 60.7417681,19.8605907 63.9921629,19.8263216 C67.2425578,19.7920525 71.6563715,24.105147 71.3788258,27.0817473 C71.1012801,30.0583476 43.132113,56.1664943 34.1621237,55.947052 C20.2142571,55.6049624 2.72395565,19.333755 0.927991958,14.4855697 C-3.88242416,1.49990154 11.3749502,-4.69449005 15.4402651,4.12195695 Z",
    id: "Path",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.104157,36.4987179 C37.0707505,39.3796803 38.2301775,40.7256022 38.582438,40.5364837 C38.9346985,40.3473652 38.5481496,38.5865073 37.4227913,35.2539101 L35.104157,36.4987179 Z",
    id: "Path-5",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(28.636714, 49.040603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.131337998,11.4345556 C-1.17743344,17.7106071 7.78537009,49.3407952 5.31948214,64.1379056 C3.36917153,75.8411793 1.50735057,91.9550494 6.56214316,95.5326829 C11.7084925,99.1751176 56.0075787,102.067458 62.3219075,91.9550494 C67.3313352,83.9324419 63.2305107,66.1412348 62.3219075,58.0254749 C60.5100845,41.8342361 63.2460628,13.8538325 60.1721248,8.13089604 C58.2651945,4.58073954 45.2650469,0.00251062222 44.7767138,0.14439664 C44.2883807,0.286282657 43.1404504,5.31657673 34.9201175,5.31657673 C26.6997845,5.31657673 23.069806,0.14439664 22.6280901,0.00251062222 C22.1863742,-0.139375395 1.3156924,5.7573113 0.131337998,11.4345556 Z",
    id: "Path",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6073972,2.99938892e-05 L22.6280901,0.00251062222 C23.069806,0.14439664 26.6997845,5.31657673 34.9201175,5.31657673 C43.1404504,5.31657673 44.2883807,0.286282657 44.7767138,0.14439664 C44.9529671,0.0931859542 46.7591253,0.6568612 49.0853301,1.56515484 L49.0747387,1.67200576 C43.1992576,11.5388666 27.0408106,12.754978 18.4036181,1.46655268 L18.2079962,1.20557655 L19.1717636,0.906609479 C20.9359257,0.370179967 22.198307,0.0479209681 22.5415959,0.00493343363 L22.6073972,2.99938892e-05 Z",
    id: "Path",
    fill: "#FF9B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.159126027,15.7938733 L0.883406431,15.8945814 C8.56693565,16.9936343 13.073267,18.732495 14.4024005,21.1111635 C15.2744651,22.6718439 14.8689728,27.9507044 13.1859238,36.9477449 L13.007258,37.8917367 C11.4462806,46.0471153 13.2310782,54.483554 17.9434835,61.2895841 L18.2082931,61.6660074 C19.8019322,63.8957866 21.2710852,66.8316741 22.6157522,70.47367 C25.7348044,78.9215423 19.1002756,86.0399759 23.3021784,98.6079939 L22.4443199,98.545049 C14.6335852,97.9469458 8.3166757,96.7744894 6.56214316,95.5326829 C1.50735057,91.9550494 3.36917153,75.8411793 5.31948214,64.1379056 C7.41764597,51.5474057 1.24156008,26.7699387 0.159126027,15.7938733 Z",
    id: "Path",
    fillOpacity: 0.0667613636,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rarm",
    transform: "translate(0.000000, 54.330575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(32.005886, 73.370299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76804522,0 C5.76804522,0 8.71714937,3.47899733 11.2342275,3.91192529 C13.7513057,4.34485324 24.2852354,6.40540653 24.9281468,6.71051565 C25.5358586,6.99891992 27.6140006,8.09291391 29.3911303,9.84845277 C30.9307911,11.369519 33.5943922,14.9755882 32.7013411,15.5960389 C31.7466797,16.2597769 29.1692134,13.0072203 27.8759941,12.2033999 C26.5199681,11.3598996 24.4359829,10.6131944 24.4359829,10.6131944 C24.4359829,10.6131944 29.5909154,16.8321307 29.2631244,17.9185206 C29.0238608,18.7115192 24.6404324,20.0656787 23.7031176,19.9640739 C22.7658028,19.862469 17.6008224,16.0806157 15.2793681,15.6405286 C13.6691247,15.3357141 6.46011494,13.3829778 4.93959529,11.9166218 C3.41967381,10.4496647 -3.48174241e-14,7.4730644 -3.48174241e-14,7.4730644 L5.76804522,0 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.269407,18.6394576 C24.6730425,15.0156046 22.7998244,13.2345624 22.6497527,13.2963311 C22.4996809,13.3580998 24.066528,15.2652426 27.3502939,19.0177595 L28.269407,18.6394576 Z",
    id: "Path",
    fill: "#F28585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8649843,19.5321735 C23.170943,17.0637106 21.7358757,15.8889445 21.5597824,16.0078752 C21.3836891,16.1268059 22.4625756,17.4021378 24.7964418,19.8338708 L25.8649843,19.5321735 Z",
    id: "Path",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.7061056,0.901414121 C49.0356103,6.76272458 43.4707955,17.4173073 36.560267,27.1906086 C30.1049374,36.3194107 20.320854,50.0703301 20.320854,50.0703301 C20.320854,50.0703301 38.718424,70.2229543 40.4955537,73.9516708 C42.2726835,77.6803872 37.7344527,84.6833039 32.092619,82.7708487 C26.4501872,80.8583935 -5.65754776,57.0734335 0.871720953,45.8329884 C10.8445519,28.6642878 30.8675898,-6.02175808 40.7061056,0.901414121 Z",
    id: "Path",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.320854,50.0703301 C17.8039375,47.4075159 16.6630525,45.9220729 16.898199,45.614001 C17.1333455,45.305929 18.6692423,46.2401528 21.5058894,48.4166722 L20.320854,50.0703301 Z",
    id: "Path-6",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(307.303057, 141.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0651558,137.0925 L108.662939,137.0925 L108.662939,137.0925 L108.662939,209.2595 C108.662939,211.468639 106.872078,213.2595 104.662939,213.2595 L19.9537958,213.2595 C17.7446568,213.2595 15.9537958,211.468639 15.9537958,209.2595 L15.9537958,161.20386 C15.9537958,147.887524 26.7488194,137.0925 40.0651558,137.0925 Z",
    id: "Rectangle",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#86E5F0",
    points: "24.3298479 198.224438 91.9659275 198.224438 91.9659275 213.2595 24.3298479 213.2595"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86E5F0",
    points: "110.465784 212.714724 114.732408 223.400661 94.1071455 223.400661 97.6813789 212.714724"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#91D6FF",
    points: "40.1945327 212.714724 44.4611567 223.400661 23.835894 223.400661 27.4101274 212.714724"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86E5F0",
    points: "179.858645 212.714724 184.125269 223.400661 163.500006 223.400661 167.07424 212.714724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2555887,58.3750923 L109.189011,58.0078125 L109.189011,58.0078125 L109.189011,144.277313 L68.6670725,144.277313 L68.6670725,82.4807828 C68.6670725,69.3681901 79.1460792,58.6594329 92.2555887,58.3750923 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.683948,58.0078125 L162.364535,58.0078125 C174.426433,58.0078125 184.204535,67.7859136 184.204535,79.8478125 L184.204535,144.287925 C184.204535,145.252877 183.422286,146.035125 182.457335,146.035125 L76.5725883,146.035125 L76.5725883,146.035125 L76.5725883,82.1191725 C76.5725883,68.8028361 87.3676118,58.0078125 100.683948,58.0078125 Z",
    id: "Rectangle",
    fill: "#C6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.164238,58.0078125 C177.470764,58.0078125 184.204535,64.7415826 184.204535,73.048109 L184.204535,135.498863 C184.204535,136.463814 183.422286,137.246063 182.457335,137.246063 L154.123941,137.246063 L154.123941,137.246063 L154.123941,73.048109 C154.123941,64.7415826 160.857712,58.0078125 169.164238,58.0078125 Z",
    id: "Rectangle",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9298479,145.198687 L104.387074,145.198687 L104.387074,145.198687 L104.387074,203.124375 L24.3298479,203.124375 L24.3298479,157.798687 C24.3298479,150.8399 29.9710601,145.198687 36.9298479,145.198687 Z",
    id: "Rectangle",
    fill: "#C6F9FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4",
    transform: "translate(72.553803, 112.500000) scale(-1, 1) translate(-72.553803, -112.500000) translate(0.053803, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(28.822991, 0.409712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.81412099,50.1043504 C-1.93141019,47.6004975 -2.63909796,32.8424943 5.53044971,27.7231916 C-2.89472336,10.0514768 16.5885644,-7.49423855 29.9344407,3.32648784 C38.6836919,-0.420777018 45.9544332,14.2018197 37.8131931,25.5586618 C41.2266683,45.0586904 34.2795579,50.099252 21.756315,50.3133825 L8.81412099,50.1043504 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94780621,46.5797241 C8.94780621,46.5797241 14.174995,45.3518639 14.3563346,36.7818413 C14.5376742,28.2118187 14.4103762,25.2864514 14.4103762,25.2864514 L25.9243277,25.0785694 C25.9243277,25.0785694 26.0498372,34.6297221 26.0516257,38.0844078 C26.0564294,47.3632202 32.5180083,46.5797241 32.5180083,46.5797241 C32.5180083,46.5797241 31.1747705,54.1033326 20.7417371,54.6903286 C12.5958648,55.1493512 8.94780621,46.5797241 8.94780621,46.5797241 Z",
    id: "Path",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7263435,21.0069555 C6.58998851,20.8080858 7.42778769,28.3317123 12.7634962,28.3214984 C12.7634962,28.3214984 15.862557,39.0092558 26.6220989,39.0092558 C35.3602344,39.0092558 35.9286649,26.5524763 36.007926,24.0675062 C36.0931916,21.4179129 36.1039999,12.7133077 36.1039999,12.7133077 L11.5263895,12.7018923 L11.7263435,21.0069555 Z",
    id: "Path",
    fill: "url(#linearGradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7381768,30.972773 C24.7381768,30.972773 26.504572,33.8297076 29.9556684,32.8132641",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(27.346923, 32.002354) rotate(-18.000000) translate(-27.346923, -32.002354) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2352102,34.3829008 C27.0449904,34.7229698 27.8130612,34.7229855 28.4851583,34.3322276",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(27.360184, 34.482091) rotate(2.000000) translate(-27.360184, -34.482091) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.962937,25.1797952 C12.2858734,24.0157552 12.1429738,22.9991028 10.987671,22.5347251",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(11.550379, 23.857260) rotate(-13.000000) translate(-11.550379, -23.857260) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9136805,20.0773767 C10.9136805,20.0773767 13.7289849,23.8572649 14.2992588,23.8773416 C14.8695327,23.8974182 15.0692231,18.9614061 15.0692231,18.9614061 C18.5227395,18.6974252 27.2628741,16.9559433 29.4053476,12.898927 C30.9036413,16.4786049 33.7677924,18.0686296 35.6496414,17.7632955 L36.0063161,25.3683236 L36.8847067,10.0789851 L10.2250782,10.0789851 L10.9136805,20.0773767 Z",
    id: "Path",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(32.500454, 116.015625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8779341,82.1030268 C57.8779341,82.1030268 53.2700186,91.4152162 57.0474672,94.3497148 C60.8305962,97.2847817 70.8235062,102.784906 70.8235062,102.784906 L44.348982,101.120148 L50.2338493,80.8105516 L57.8779341,82.1030268 Z",
    id: "Path",
    fill: "url(#linearGradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9098201,90.9650665 C48.2163061,91.1179583 46.8210014,95.5192169 49.6498276,95.8539874 C52.4729734,96.1881894 53.845114,92.0183389 57.0488448,93.3402882 C60.2525757,94.6622375 71.9367376,101.496897 72.3968479,104.291008 C72.8626386,107.08455 68.5094049,107.906579 62.5393319,107.275687 C56.569259,106.644795 55.4688894,104.519655 50.9870744,105.375621 C46.5109398,106.23102 43.1577264,104.867421 43.3054162,101.594741 C43.4531059,98.3226306 45.6033341,90.8127432 46.9098201,90.9650665 Z",
    id: "Path",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5101231,94.0183121 L58.0000289,94.783695 C57.6937434,95.2432684 57.8180077,95.8641196 58.277581,96.1704051 C58.2993878,96.1849384 58.3217575,96.1986089 58.3446382,96.2113848 L66.074705,100.527648 C66.3654548,100.689994 66.7179425,100.696959 67.0148784,100.546224 L68.1844211,99.9525236 L68.1844211,99.9525236 C66.2588368,98.5570413 64.6842373,97.5085367 62.9442181,96.4790045 C61.6083834,95.6886197 60.1294511,94.8737779 58.5101231,94.0183121 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9968406,0.0277883747 C26.0118481,0.385861991 70.621122,10.2582482 78.7258721,11.9354976 C86.8306222,13.612747 93.6826637,22.6884626 87.5024169,33.197639 C80.561,44.9947437 62.6508735,78.4982477 58.3024339,86.0507663 C56.1501384,89.7889468 45.2921694,87.6930407 47.8426572,81.4187877 C52.5972242,69.7224543 54.8052499,40.3401501 66.9271677,29.6269286 C66.9271677,29.6269286 26.161292,36.7259193 8.55213296,28.594238 C-4.24574938,22.6831814 -1.35051281,-0.837840383 17.9968406,0.0277883747 Z",
    id: "Path",
    fill: "url(#linearGradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(56.673764, 49.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6133591,19.1199695 C50.6133591,19.1199695 50.5227892,12.5945957 52.8040171,9.18440424 C55.0852451,5.77421278 55.1758149,2.15184173 56.9023026,2.27041268 C58.6287902,2.38898364 56.9192844,10.8086561 56.9192844,10.8086561 C56.9192844,10.8086561 59.1099425,9.97128421 60.6835935,8.91208817 C62.2572446,7.85289212 67.0291432,2.63123148 68.1442844,3.55653879 C70.0349299,5.13313537 66.9895189,14.0265244 65.3309586,15.8045214 C63.6667378,17.5830857 54.5757897,23.4316406 54.5757897,23.4316406 L50.6133591,19.1199695 Z",
    id: "Path",
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35855029,15.2098347 C5.08694114,23.8625053 11.9137177,39.7577703 14.7280848,44.5000498 C18.2550806,50.4390081 23.816683,53.0555807 30.328457,48.6491567 C37.1707256,44.0190014 56.0111241,25.9600151 56.5636695,21.8692953 C57.111051,17.7785755 52.4996202,12.8704351 48.3271274,15.4115694 C44.1546346,17.9527037 26.8169532,32.3896177 26.8169532,32.3896177 C26.8169532,32.3896177 19.8197654,14.4425341 14.1910313,4.04599837 C9.31623769,-4.94872819 -4.31665961,2.0556671 1.35855029,15.2098347 Z",
    id: "Path",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8892489,32.3989183 C28.1421205,36.6509199 28.9149956,38.6538242 29.2078742,38.4076313 C29.5007528,38.1614383 29.3888666,35.6029085 28.8722157,30.7320417 L26.8892489,32.3989183 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PhoneMini4",
    transform: "translate(119.643271, 61.431243) scale(-1, 1) rotate(-18.000000) translate(-119.643271, -61.431243) translate(111.143271, 45.931243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.86956228,1.09124984 L12.8265251,1.09124984 C14.1520085,1.09124984 15.2265251,2.16576644 15.2265251,3.49124984 L15.2265251,28.2224998 C15.2265251,29.5479832 14.1520085,30.6224998 12.8265251,30.6224998 L2.86956228,30.6224998 C1.54407888,30.6224998 0.469562276,29.5479832 0.469562276,28.2224998 L0.469562276,3.49124984 C0.469562276,2.16576644 1.54407888,1.09124984 2.86956228,1.09124984 Z",
    id: "Rectangle",
    fill: "#7596FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#93C2F9",
    x: 1.58110316,
    y: 0.703125,
    width: 14.7569628,
    height: 29.53125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2188049,1.7578125 L5.33799212,1.7578125 C5.56599772,1.7578125 5.75562951,1.92220677 5.79495503,2.13899716 L5.80243787,2.22253088 C5.80243787,2.47918775 6.01037731,2.68724925 6.26688362,2.68724925 L11.6635838,2.68724925 C11.8915894,2.68724925 12.0812212,2.52285498 12.1205467,2.30606459 L12.1280295,2.22253088 C12.1280295,1.965874 12.335969,1.7578125 12.5924753,1.7578125 L13.7060134,1.7578125 C14.5332031,1.7578125 15.2116038,2.3952277 15.2773759,3.20594615 L15.2826017,3.33672198 L15.2826017,3.33672198 L15.2613759,27.3515186 C15.2587711,28.3993392 14.4095819,29.2482757 13.3623741,29.2499578 L4.50819644,29.2499578 C3.5058927,29.2515606 2.68511385,28.4739737 2.61563649,27.4887746 L2.61087264,27.353196 C2.61087264,27.3526364 2.61087264,27.3520767 2.6125506,27.3515186 L2.6337714,3.34237442 C2.63454509,2.46701845 3.3439621,1.7578125 4.2188049,1.7578125 Z",
    id: "Rectangle",
    fill: "#E6F3FF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(20.771497, 45.468402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.81560135 C0,8.81560135 8.98480399,38.9184837 9.2508946,44.6167316 C9.5169852,50.315546 1.90226474,67.0641689 3.19874874,71.297493 C6.18802191,81.08008 44.3522082,85.2924442 45.8103024,72.1324883 C46.4903109,65.9951059 45.0751649,60.4867401 46.7056775,53.255024 C48.3305287,46.0233078 54.8617482,35.2768766 51.1573339,25.1733513 C47.4529196,15.069826 48.4454743,5.7224941 45.7958913,3.9557476 C43.1463083,2.1890011 36.9526249,0.312698364 36.9526249,0.312698364 C33.9407057,4.7476902 23.7726477,4.68311119 18.9207404,-4.99600361e-14 C18.9207404,-4.99600361e-14 6.86740217,2.33957291 0,8.81560135 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05149407,13.6910849 C14.0405445,23.2011772 14.0225389,39.7591397 17.2390903,41.927664 C20.4556417,44.0961883 32.9747649,41.9681432 32.9747649,43.6854765 C32.9747649,45.4028098 15.6741242,61.1411965 18.5142686,68.6648818 C20.0014208,72.6044229 19.5980204,76.1288255 17.3040675,79.2380896 L16.5552862,79.0748241 C9.73869301,77.5333912 4.25845666,74.7654547 3.19874874,71.297493 C1.90226474,67.0641689 10.3953758,50.315546 10.1292852,44.6167316 C9.90340928,39.7796678 2.76207203,17.3571632 0.608670792,10.6901567 C2.36188024,7.5952271 4.84239668,8.59531687 8.05149407,13.6910849 Z",
    id: "Path",
    fillOpacity: 0.199355332,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 51.767578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0356802,32.6227209 C39.0356802,32.6227209 46.6035164,25.9207998 48.920201,25.1430502 C51.2368855,24.3653006 64.8052206,23.43098 64.7194175,25.1884332 C64.622174,27.0712566 57.334628,26.9629049 56.5795605,27.8892835 C55.8244929,28.8150948 55.6528866,35.1460106 52.7985025,35.8568204 C49.9498385,36.5676302 41.4095669,37.7929687 41.4095669,37.7929687 L39.0356802,32.6227209 Z",
    id: "Path",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9022528,4.24640534 C10.9290734,15.5058313 4.12176896,32.6566825 1.50879698,39.3433069 C-1.10417501,46.0299312 1.53166601,56.1154868 13.0215132,54.1354896 C24.4907044,52.1606593 42.7391671,41.4303315 44.7582818,38.3001584 C46.7773965,35.1699853 43.7099947,29.4743192 39.8473404,30.2199184 C36.2687049,30.9097139 18.5179054,38.4618858 18.5179054,38.4618858 C18.5179054,38.4618858 29.93767,18.2081762 32.7262172,12.7786847 C37.3841237,3.71110337 25.9252605,-5.67424896 18.9022528,4.24640534 Z",
    id: "Path",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6986445,38.32341 C14.7111283,40.3056614 12.9605404,40.8811184 13.4468807,40.049781 C13.933221,39.2184435 16.4446348,37.3424508 20.981122,34.4218026 L18.6986445,38.32341 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(19.324594, 112.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8932823,85.9925118 C98.8932823,85.9925118 98.7543679,96.9529747 107.780482,101.050928 C116.800916,105.148313 123.227683,104.901641 122.409709,108.06974 C121.591736,111.23727 98.1123913,111.109389 95.919767,108.63186 C94.050924,106.524341 89.9870222,86.8990651 88.8679886,88.3995641 L98.8932823,85.9925118 Z",
    id: "Path",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7519956,98.2613643 C92.7599648,96.3127211 92.823329,101.794627 96.7990927,100.586488 C100.025545,99.6060465 101.128464,93.9950413 103.167282,95.2239094 C105.206101,96.4527775 123.152293,105.981624 123.254539,106.03903 C125.464205,107.229767 124.846667,110.837705 121.114661,111.46746 C116.967988,112.166556 95.4818121,111.695947 94.3286962,110.589898 C93.1755803,109.483848 90.9437124,99.8239669 91.7519956,98.2613643 Z",
    id: "Path",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.821799,98.5012031 C105.559672,98.5012031 105.30419,98.6855641 105.055352,99.0542861 C104.746407,99.5120752 104.867068,100.133636 105.324857,100.442582 C105.380957,100.480442 105.440756,100.51251 105.503334,100.53829 L114.82686,104.37938 C115.186938,104.527688 115.59908,104.35605 115.747419,103.995986 C115.823508,103.811295 115.817691,103.602998 115.731415,103.422841 C115.731415,103.422841 115.731415,103.422841 115.731415,103.422841 C115.556355,103.05729 106.497927,98.5012031 105.821799,98.5012031 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18072722,0.155092167 C-2.58750982,16.570401 -1.0131809,27.5963945 9.90371397,33.2330727 C25.7400202,41.4097715 73.1485258,31.738932 73.1485258,31.738932 C73.1485258,31.738932 72.3013768,38.5634555 73.1485258,44.650108 C75.3610707,60.5469473 85.8837304,87.0318938 88.1100644,90.359792 C91.1888271,94.9618905 100.567352,91.4911952 100.74401,87.6592259 C100.920668,83.8272566 93.6740001,34.8865564 92.5720075,25.5539076 C91.4756954,16.2206904 88.0145129,14.8650067 77.9052822,12.3137093 C75.5828276,11.7275844 48.1183767,4.89821757 45.6023973,5.09727322 C31.1903159,6.2375076 17.7164259,4.59011391 5.18072722,0.155092167 Z",
    id: "Path",
    fill: "#2C3757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9543048,30.6919082 C33.6327768,32.4497207 75.140884,28.8263787 76.8079424,30.4728296 C78.3995259,32.0447386 78.1339742,59.3924369 81.7042631,75.221046 L81.1612833,73.7263342 C77.8035635,64.3950306 74.3170618,53.0458827 73.1485258,44.650108 C72.3013768,38.5634555 73.1485258,31.738932 73.1485258,31.738932 L71.236957,32.1091606 C62.2251241,33.802929 23.8396634,40.4285677 9.90371397,33.2330727 C2.35273957,29.3343072 -0.728580762,22.8571949 0.659752975,13.8017359 C3.050394,24.0369834 8.8152296,29.6672688 17.9543048,30.6919082 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.46156529
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M115.606751,137.0925 L184.204535,137.0925 L184.204535,137.0925 L184.204535,211.5123 C184.204535,212.477252 183.422286,213.2595 182.457335,213.2595 L91.4953912,213.2595 L91.4953912,213.2595 L91.4953912,161.20386 C91.4953912,147.887524 102.290415,137.0925 115.606751,137.0925 Z",
    id: "Rectangle",
    fill: "#86E5F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    transform: "translate(503.001631, 295.119048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.6190476 L7.04676455,17.6190476 C13.8582765,17.6190476 19.3800979,23.140869 19.3800979,29.952381 L19.3800979,29.952381 L19.3800979,29.952381 L12.3333333,29.952381 C5.52182142,29.952381 8.34169626e-16,24.4305595 0,17.6190476 L0,17.6190476 L0,17.6190476 Z",
    id: "Rectangle",
    fill: "#2CE780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8091354,10.5714286 L14.0943448,10.5714286 C17.5001007,10.5714286 20.2610114,13.3323393 20.2610114,16.7380952 L20.2610114,16.7380952 L20.2610114,16.7380952 L14.9758021,16.7380952 C11.5700461,16.7380952 8.8091354,13.9771845 8.8091354,10.5714286 L8.8091354,10.5714286 L8.8091354,10.5714286 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3800979,16.7380952 L25.5460266,16.7380952 C31.3844654,16.7380952 36.1174551,21.471085 36.1174551,27.3095238 L36.1174551,27.3095238 L36.1174551,27.3095238 L29.9515265,27.3095238 C24.1130877,27.3095238 19.3800979,22.576534 19.3800979,16.7380952 L19.3800979,16.7380952 L19.3800979,16.7380952 Z",
    id: "Rectangle",
    fill: "#28C76F",
    transform: "translate(27.748777, 22.023810) scale(-1, 1) translate(-27.748777, -22.023810) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3887967,7.64189295 L22.8027286,7.65128788 C27.0293405,7.65862243 30.4538521,11.0831553 30.4611604,15.3097672 L30.4611604,15.3097672 L30.4611604,15.3097672 L25.0472284,15.3003723 C20.8206166,15.2930377 17.396105,11.8685048 17.3887967,7.64189295 L17.3887967,7.64189295 L17.3887967,7.64189295 Z",
    id: "Rectangle",
    fill: "#2CE780",
    transform: "translate(23.924979, 11.475830) scale(-1, 1) rotate(22.000000) translate(-23.924979, -11.475830) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6491652,4.4047619 C18.4047686,6.15190905 20.1527468,9.47524632 20.2561545,13.1232911 L20.2610114,13.4662084 L20.2610114,39.6428571 L18.8471075,39.6428571 L18.8471075,13.4662084 C18.8471075,10.3973378 17.4585246,7.56672707 15.2110678,6.01515874 L14.9755302,5.85925692 L15.6491652,4.4047619 Z",
    id: "Path",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(3.523654, 30.833333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#DA4E4F",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.892094437,-1.74751773 L8.02884993,-1.74751773 C4.09210488,13.2700104 13.6805395,25.7241042 8.02884993,41.0666667 L-0.892094437,41.0666667 L-0.892094437,-1.74751773 Z",
    id: "Rectangle",
    fill: "#E95B5C",
    mask: "url(#mask-23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.257949082,
    fill: "#FFDFE2",
    mask: "url(#mask-23)",
    x: -2.37701708e-13,
    y: 23.5914894,
    width: 32.6506564,
    height: 3.49503546
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.257949082,
    fill: "#FFDFE2",
    mask: "url(#mask-23)",
    x: 1.64806518e-13,
    y: 13.9801418,
    width: 32.6506564,
    height: 3.49503546
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.78110384,2.17990852 L14.1050865,2.18563441 C17.7281885,2.19043219 20.6640913,5.12635138 20.6688688,8.74945346 L20.6688688,8.74945346 L20.6688688,8.74945346 L16.3448862,8.74372757 C12.7217842,8.73892979 9.78588137,5.8030106 9.78110384,2.17990852 L9.78110384,2.17990852 L9.78110384,2.17990852 Z",
    id: "Rectangle",
    fill: "#2CE780",
    transform: "translate(15.224986, 5.464681) rotate(16.000000) translate(-15.224986, -5.464681) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.51731f258f33c04407ca3e979c9f62a0.svg";
export { ForwardRef as ReactComponent };